import { makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
export const useStyles = makeStyles({
    wrapper: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    itemsWrapper: {
        height: '100%',
        overflowY: 'scroll',
    },
    items: {
        overflowY: 'scroll',
        padding: 10,
        marginTop: 10,
        margin: 0,
        fontFamily: 'PoppinsRegular',
        maxHeight: '85vh',
    },
    item: {
        width: '100%',
    },
    itemImage: {
        width: '100%',
        aspectRatio: '1',
        borderRadius: 5,
        objectFit: 'cover',
        objectPosition: 'center',
        minWidth: 130,
        minHeight: 190,
    },
    itemTitle: {
        color: themes.palette.primary.main,
        marginBottom: 0,
        marginTop: 5,
        fontSize: 14,
    },
    itemPrice: {
        color: themes.palette.primary.main,
        fontWeight: 700,
        fontSize: 14,
    },
    iconContainer: {
        position: 'absolute',
        bottom: 20,
        right: 0,
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    filtersWrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItem: 'center',
        width: '100%',
        overflowX: 'auto',
        '& button': {
            border: '1px solid',
            backgroundColor: 'transparent',
            borderRadius: 71,
            color: themes.palette.primary.main,
            fontWeight: '700',
            fontSize: 12,
            padding: '10px 15px',
            margin: 8,
            width: 'fit-content',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& buttonActive': {
            backgroundColor: 'white',
        },
        '@media (min-width: 365px)': {
            justifyContent: 'center',
        },
    },
    activeButton: {
        backgroundColor: `${themes.palette.primary.main} !important`,
        color: `${themes.palette.common.white} !important`,
        border: 'none',
    },
    filterWrap: {
        paddingBottom: 3,
    },
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        // marginBottom: 10
    },
    filterSwiperWrapper: {
        display: 'flex',
        flex: 1,
        width: '100%',
        overflowX: 'auto',
    },
    firstFilterChipWrap: {
        paddingLeft: 0,
        paddingRight: '6px',
        flex: 1,
        '& .MuiChip-root': {
            width: '100%',
        },
    },
    filterChipWrap: {
        paddingLeft: '6px',
        paddingRight: '6px',
        flex: 1,
        '& .MuiChip-root': {
            width: '100%',
        },
    },
    chipActive: {
        backgroundColor: themes.palette.primary.main,
        '&.MuiChip-clickable.MuiChip-outlined:hover': {
            backgroundColor: `${themes.palette.primary.main} !important`,
        },
        '&.MuiChip-clickable.MuiChip-outlined:focus': {
            backgroundColor: `${themes.palette.primary.main} !important`,
        },
    },
    chipOutline: {
        border: '1px solid #4A6C72',
        marginRight: '6px',
        maxWidth: '180px',
    },
    chipFilterOutline: {
        border: '1px solid #4A6C72',
        height: 32,
        width: 32,
    },
    badgeFilter: {
        '& > span': {
            position: 'relative',
            transform: 'none !important',
            marginRight: '6px',
        },
    },
    chipLabel: {
        padding: '0 8px',
        color: themes.palette.primary.main,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipFilterLabel: {
        display: 'none',
    },
    chipLabelActive: {
        padding: '0 8px',
        color: `${themes.palette.common.white}`,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipIcon: {
        color: `${themes.palette.primary.main}`,
    },
    chipFilterIcon: {
        color: `${themes.palette.primary.main}`,
        margin: '0 !important',
    },
    chipIconActive: {
        color: `${themes.palette.common.white}`,
    },
    loaderWrapper: {
        color: '#000000',
        width: '100%',
        textAlign: 'center',
    },
});
